import { render, staticRenderFns } from "./referential-agency.vue?vue&type=template&id=3a57d6df&"
import script from "./referential-agency.vue?vue&type=script&lang=ts&"
export * from "./referential-agency.vue?vue&type=script&lang=ts&"
import style0 from "./referential-agency.vue?vue&type=style&index=0&id=3a57d6df&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports